import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import CircularProgress from "../common/CircularProgress/CircularProgress";
import { DashboardIcon } from "../common/Dashboard";
import {
  AdminWidgetTitle,
  AdminMetadataText,
  AdminSupportingText,
  AdminHeaderAction,
  AdminStatusBadge,
} from "../../sections/AdminDashboard/shared/adminUx";

const AccountInfoWidget = () => {
  const navigate = useNavigate();

  const taskData = {
    profileCompletion: 85,
  };

  const loginData = {
    lastLoginDate: "Nov 31, 2024",
    lastLoginTime: "2:15 PM",
    ipAddress: "192.168.232.7",
    location: "Melbourne",
    device: "Laptop",
    isTrusted: true,
  };

  return (
    <DashboardMainContainer className="masonry-item w-[400px] h-[400px] flex flex-col">
      <div className="py-3 px-4 border-b border-mediumgray">
        <AdminWidgetTitle className="text-offblack">Account & Profile</AdminWidgetTitle>
      </div>

      <div className="flex-1 p-4 space-y-4">
        <div className="flex items-center justify-between">
          <CircularProgress progress={taskData.profileCompletion} />
          <div className="text-left">
            <AdminHeaderAction type="button" onClick={() => navigate("/customer-dashboard/account")}>
              Complete profile
            </AdminHeaderAction>
          </div>
        </div>

        <div className="border-t border-lightgray" />

        <div>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <DashboardIcon size="regular" className="text-offblack shrink-0">
                <i className="fi fi-rs-clock" aria-hidden />
              </DashboardIcon>
              <div className="flex-1">
                <AdminSupportingText className="text-offblack block">Last Login</AdminSupportingText>
                <AdminMetadataText className="text-offblack block">
                  {loginData.lastLoginDate} {loginData.lastLoginTime}
                </AdminMetadataText>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <i className="fi fi-rs-globe text-offblack text-base" aria-hidden />
              <div className="flex-1">
                <AdminSupportingText className="text-offblack block">IP Address</AdminSupportingText>
                <AdminMetadataText className="text-offblack block">{loginData.ipAddress}</AdminMetadataText>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <DashboardIcon size="regular" className="text-offblack shrink-0">
                <i className="fi fi-rs-marker" aria-hidden />
              </DashboardIcon>
              <div className="flex-1">
                <AdminSupportingText className="text-offblack block">Location</AdminSupportingText>
                <AdminMetadataText className="text-offblack block">{loginData.location}</AdminMetadataText>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <DashboardIcon size="regular" className="text-offblack shrink-0">
                <i className="fi fi-rs-laptop" aria-hidden />
              </DashboardIcon>
              <div className="flex-1 min-w-0">
                <AdminSupportingText className="text-offblack block">Device</AdminSupportingText>
                <div className="flex items-center justify-between gap-2">
                  <AdminMetadataText className="text-offblack">{loginData.device}</AdminMetadataText>
                  {loginData.isTrusted ? (
                    <AdminStatusBadge status="Active" label="Trusted Device" />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default AccountInfoWidget;
